import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {RoleUtil} from 'src/app/shared/util/role-util';

import {Principal} from 'src/app/core';
import {ICargoGroupMySuffix} from 'src/app/shared/model/cargo-group-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';


@Component({
    selector: 'jhi-cargo-group-my-suffix-detail',
    templateUrl: './cargo-group-my-suffix-detail.component.html'
})
export class CargoGroupMySuffixDetailComponent implements OnInit {
    cargoGroup: ICargoGroupMySuffix;
    isShowPastHistory: any;
    isShowFutureHistory: any;

    public readonly RoleUtil=RoleUtil;

    constructor(private principal: Principal,
         private activatedRoute: ActivatedRoute,
         private languageChangeService:LanguageChangeService,
     ) { 
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                  window.history.back();
            }
    });
     }

    ngOnInit() {
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ cargoGroup }) => {
            this.cargoGroup = cargoGroup;
        });

        
        // this.languageChangeService.currentLanguage.subscribe(language => {
        //     console.log(language);
        // });
    }

    previousState() {
        window.history.back();
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Cargo (' + Obj.name + ') History';
        this.historyType = "CARGO_GROUP_AUDIT";
        this.historyId = Obj.id;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Cargo (' + Obj.name + ') Future Records';
        this.historyType = "CARGO_GROUP_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
}
